import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { store } from './app/store';
import { Provider } from 'react-redux';
import { init } from './backend/baseUrl';

// Run the same-domain connection test once, as early as possible, so the
// first real API call doesn't wait for it.
init();

ReactDOM.render( <Provider store={store}>
  <App />
</Provider>, document.getElementById('root') );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
